import { Component, Input, OnInit, OnChanges, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { Note } from '../../models/note/note';
import { NoteService } from 'src/app/services/note.service';
import { ClientNotesResponse } from '../../models/note/client-notes-response';

@Component({
  selector: 'app-notes',
  templateUrl: './notes.component.html',
  styleUrls: ['./notes.component.scss'],
})
export class NotesComponent implements OnInit, OnChanges {
  @Input() clientId: number;
  @Input() newNote: Note;
  @Input() isWealth: boolean = false;
  @Output() noteAddedToList = new EventEmitter<boolean>();
  @Output() notesError = new EventEmitter<any>();

  clientNotes: Note[] = [];
  noNotes: boolean = false;

  clientNotesResponse: ClientNotesResponse;
  noteText: string;
  loadingNotes: boolean = false;

  searchText: string = '';

  errorMessage: string | null;

  constructor(private noteService: NoteService) {}

  ngOnInit(): void {
    this.GetClientNotes();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['newNote']) {
      const noteChange = changes['newNote'];

      if (!noteChange.firstChange && (noteChange.currentValue !== noteChange.previousValue || noteChange.previousValue === undefined)) {
        this.handleRecordAdded();
      }
    }
  }

  GetClientNotes() {
    this.loadingNotes = true;
    this.noteService.GetOnboardingClientNotes(this.clientId, this.isWealth).subscribe({
      next: (response: ClientNotesResponse) => {
        this.clientNotes = response.notes;
        this.noNotes = this.clientNotes.length == 0;
      },
      error: (error) => {
        this.notesError.emit(error);
      },
      complete: () => {
        this.loadingNotes = false;
      },
    });
  }

  handleRecordAdded() {
    this.newNote.recentlyUpdated = true;
    setTimeout(() => {
      this.newNote.recentlyUpdated = false;
    }, 3000);

    if (this.clientNotes.length == 0) {
      this.GetClientNotes();
    } else {
      this.clientNotes.unshift(this.newNote);
    }

    this.noteAddedToList.emit(true);
  }
}
